<div class="surface-card p-4 border-1 border-200 border-round-md">
    <div class="flex justify-content-between align-items-center mb-3">
      <div class="text-900 font-medium">Revenue</div>
      <p-calendar
      [(ngModel)]="yearOptions"
      (onSelect)="onYearChange($event)"
      view="year"
      dateFormat="yy"
      inputStyleClass="w-full"
    ></p-calendar>
        </div>
  
    <!-- Scrollable container -->
    <div style="overflow-x: auto">
      <div style="min-width: 768px">
        <p-chart
          #chart
          id="myChart"
          type="bar"
          [data]="chartData"
          [options]="chartOptions"
          styleClass="w-full h-20rem"
        ></p-chart>
      </div>
    </div>
  
    <div class="flex justify-content-end mt-4">
      <div class="flex flex-column align-items-end">
        <div class="text-900 text-sm">Total Revenue</div>
        <div class="flex align-items-center gap-2">
          <span class="text-gradient font-bold text-xl">${{ totalRevenue | number:'1.2-2' }}</span>
          <!-- <span class="text-green-500 text-xs">+3% vs last year total</span> -->
        </div>
      </div>
    </div>
  </div>